import type {
  Connection,
  ConnectionDefaults,
  OAuthFailureReason,
  PlatformId,
  TestConnectionResponse
} from '@utils/types/connections/connection.ts';

export type WizardStepId = 1 | 2 | 3 | 4 | 5 | 6;

/** User-visible authorization error after a cancelled / blocked / expired attempt. */
export type AuthErrorKind = OAuthFailureReason | 'credentials_invalid';

export interface WizardState {
  platformId: PlatformId | null;
  attemptId: string | null;
  authorizeUrl: string | null;
  oauthCode: string | null;
  credentials: Record<string, string>;
  defaults: ConnectionDefaults;
  authError: AuthErrorKind | null;
  finalizedConnection: Connection | null;
  testResult: TestConnectionResponse | null;
  /** True while the wizard is awaiting backend finalize + test. */
  isFinalizing: boolean;
  /** True while the OAuth popup is open. */
  isAuthorizing: boolean;
}

export const INITIAL_STATE: WizardState = {
  platformId: null,
  attemptId: null,
  authorizeUrl: null,
  oauthCode: null,
  credentials: {},
  defaults: {},
  authError: null,
  finalizedConnection: null,
  testResult: null,
  isFinalizing: false,
  isAuthorizing: false
};
